import { render, staticRenderFns } from "./GamanzaSidebar.vue?vue&type=template&id=275e9e1a&scoped=true"
import script from "./GamanzaSidebar.vue?vue&type=script&lang=js"
export * from "./GamanzaSidebar.vue?vue&type=script&lang=js"
import style0 from "./GamanzaSidebar.vue?vue&type=style&index=0&id=275e9e1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "275e9e1a",
  null
  
)

export default component.exports